import React from 'react';
import './About.css';

const About = () => {
  const features = [
    {
      icon: '🏥',
      title: 'G.M.P. Certified',
      description: 'All products manufactured under Good Manufacturing Practice standards for pharmaceutical quality.'
    },
    {
      icon: '🌿',
      title: 'Herbal Formulations',
      description: 'Authentic Ayurvedic ingredients like Ashwagandha, Shatavari, Brahmi, and traditional herbs.'
    },
    {
      icon: '👨‍⚕️',
      title: 'Specialized Categories',
      description: 'Comprehensive range covering Women\'s Health, Digestive, Respiratory, Liver, and Pediatric care.'
    },
    {
      icon: '📋',
      title: 'Detailed Compositions',
      description: 'Complete ingredient transparency with precise dosage information for informed healthcare choices.'
    }
  ];

  const stats = [
    {
      number: '8+',
      label: 'Specialized Products'
    },
    {
      number: '7',
      label: 'Health Categories'
    },
    {
      number: '100%',
      label: 'G.M.P. Certified'
    },
    {
      number: '24',
      label: 'Herbal Ingredients'
    }
  ];

  return (
    <section className="about section">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">Why Choose Shiv Ayurvedic Pharmacy?</h2>
            <p className="about-description">
              At Shiv Ayurvedic Pharmacy, we specialize in G.M.P. certified herbal formulations 
              that combine time-tested Ayurvedic wisdom with modern pharmaceutical standards. 
              Our comprehensive range covers Women's Health, Digestive Care, Respiratory Support, 
              Liver Health, Pain Relief, Pediatric Care, and Diabetes Management.
            </p>
            <p className="about-description">
              Every product is carefully formulated with authentic herbal ingredients, rigorously 
              tested for safety and efficacy. From HEMA-CORDIAL for menstrual health to DYLOWIN 
              for diabetes care, we provide natural solutions backed by traditional knowledge.
            </p>
            
            <div className="stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-number">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="about-image">
            <div className="image-placeholder">
              <div className="floating-element element-1">🌿</div>
              <div className="floating-element element-2">🧘‍♀️</div>
              <div className="floating-element element-3">⚖️</div>
            </div>
          </div>
        </div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
        
        <div className="about-cta">
          <h3>Ready to Start Your Wellness Journey?</h3>
          <p>Discover the transformative power of authentic Ayurvedic products.</p>
          <a href="/products.html" className="btn btn-primary">Explore Products</a>
        </div>
      </div>
    </section>
  );
};

export default About;